import request from '@/utils/request'

export function login(data) {
  return request({
    url: 'login.yy',
    method: 'post',
    data
  })
}

export function getInfo(token) {
  return request({
    url: 'login_member.yy',
    method: 'get',
    params: { token }
  })
}

export function logout() {
  return request({
    url: '/user/logout',
    method: 'post'
  })
}
